import { Component } from '@angular/core';
import {personModel, statsRecord, teamModel} from "../../model/personModel";
import * as moment from 'moment';
declare var FB: any;

@Component({
    selector: 'group-profile',
    templateUrl: 'group-profile.page.html'
})
export class groupProfilePage {  
    week: number;  
    metric: string = "week";
    constructor( 
        public persons: teamModel       
    ) {   
        console.log(persons);     
        var now = moment(new Date());
        this.week=now.week();
    }     
    getItem(key, metric) {
        var now = moment(new Date());
        var metricno = 1;
        if (metric == 'week') metricno = now.week();
        else if (metric == 'year') metricno = now.year();
        else if (metric == 'month') metricno = now.month() + 1

        return this.persons.getItem(key, metric, metricno);
    }
    display(val) {
        this.metric = val;
    }
}





// WEBPACK FOOTER //
// ./src/pages/groupProfile/group-profile.page.ts